import React from 'react';
import Sym from './Sym';

/**
 * Campo de formulario: etiqueta + control + ayuda/error.
 * Envuelve un <input>, <select> o <textarea> con la clase .a2-input.
 */
export const Field = ({ label, hint, error, htmlFor, className = '', children, ...rest }) => (
  <div className={className} {...rest}>
    {label ? <label className="a2-label" htmlFor={htmlFor}>{label}</label> : null}
    {children}
    {error ? <p className="a2-error">{error}</p> : hint ? <p className="a2-hint">{hint}</p> : null}
  </div>
);

/** Input de texto con el estilo del rediseño. `mono` para RFC/UUID/fechas. */
export const Input = ({ mono = false, className = '', ...rest }) => (
  <input
    className={['a2-input', mono ? 'a2-input--mono' : '', className].filter(Boolean).join(' ')}
    {...rest}
  />
);

export const Textarea = ({ className = '', ...rest }) => (
  <textarea className={['a2-input', className].filter(Boolean).join(' ')} {...rest} />
);

export const Select = ({ className = '', children, ...rest }) => (
  <select className={['a2-input', className].filter(Boolean).join(' ')} {...rest}>
    {children}
  </select>
);

/** Buscador con icono. Controlado: value + onChange. */
export const SearchInput = ({
  value, onChange, placeholder = 'Buscar…', className = '', style, ...rest
}) => (
  <div className={['a2-search', className].filter(Boolean).join(' ')} style={style}>
    <Sym name="search" size={20} style={{ color: 'var(--muted)', flexShrink: 0 }} />
    <input
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
    />
  </div>
);

export default Field;
